var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnpin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6355 6.90332L9.323 4.52832H10.5105C10.9167 4.52832 11.2605 4.21582 11.2605 3.77832V1.27832C11.2605 0.87207 10.9167 0.52832 10.5105 0.52832H2.0105C1.573 0.52832 1.2605 0.87207 1.2605 1.27832V3.77832C1.2605 4.21582 1.573 4.52832 2.0105 4.52832H3.16675L2.85425 6.90332C1.323 7.77832 0.260498 9.24707 0.260498 11.0283C0.260498 11.2783 0.479248 11.5283 0.760498 11.5283H5.7605V15.2783C5.7605 15.3096 5.7605 15.3408 5.7605 15.3408L6.0105 16.3408C6.073 16.5908 6.41675 16.5908 6.47925 16.3408L6.72925 15.3408C6.72925 15.3408 6.72925 15.3096 6.72925 15.2783V11.5283H11.7292C12.0105 11.5283 12.2292 11.2783 12.2292 11.0283C12.2605 9.24707 11.1667 7.77832 9.6355 6.90332ZM1.29175 10.5283C1.5105 9.18457 2.5105 8.12207 3.7605 7.55957L4.2605 3.52832H2.2605V1.52832H10.2605V3.52832H8.2605L8.72925 7.55957C9.97925 8.12207 11.0105 9.18457 11.198 10.5283H1.29175Z",
    fill: "#383838"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpin);
export default __webpack_public_path__ + "static/media/unpin.a1d3409c.svg";
export { ForwardRef as ReactComponent };